import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { isAcceptablePdf } from 'src/app/utils/helper/utilities';
import { FormService } from 'src/app/utils/services/forms/forms.service';
import { AppService } from 'src/app/utils/services/app.service';

@Component({
  selector: 'app-loa-cpuploader',
  templateUrl: './loa-cpuploader.component.html',
  styleUrls: ['./loa-cpuploader.component.scss']
})
export class LoaCpUploaderComponent implements OnInit {

  @Output()
  uploaded: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  patientID: any;

  document: any;
  modal = false;
  processing = false;
  tags: any = [];
  form: FormGroup;
  file: any;
  preview: any;
  name: string;
  md_id: any;
  confirmationModal = false;
  currentUser: any;

  constructor(
    private service: FormService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private _appService: AppService
  ) {
    this.currentUser = _appService.getCurrentUser();
  }

  ngOnInit(): void {
  }

  createForm() {
    this.form = this.fb.group({
      id: [this.document?.id],
      patient_id: [this.patientID || '99999'],
      md_id: [this.document?.md_id, Validators.required],
      renamed: [this.document?.renamed],
      version: [this.document?.version],
      type: [this.document?.type],
      source: [this.document?.source || 'uploaded'],
      description: [this.document?.description],
      tags: [],
    });
  }

  previewUploadFile(event) {
    var id = event.target.id;
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;

      if (!isAcceptablePdf(file?.type)) {
        this.toastr.error('File should be pdf', '', { timeOut: 1000 });
        return;
      }

      reader.readAsDataURL(file);

      reader.onload = () => {
        this.form.patchValue({
          type: file?.type
        })
        this.file = file;
        this.preview = reader.result as string;
      };
    }
  }


  onOpen(document = null) {
    this.document = document;
    this.preview = this.document?.url;
    this.modal = true;
    this.createForm();
    // // Explicitly set md_id control to null
    // this.form.get('md_id')?.setValue(null);
    // setTimeout(() => {
    //   this.updateTags();
    // }, 1);
  }

  onClose() {
    this.modal = false;
    this.file = null;
    this.name = null;
    this.md_id = null;
    this.preview = null;
    this.textInput = null;
    this.tags = [];
  }

  getControl(name) {
    return this.form.get(name);
  }

  async upload() {
    this.confirmationModal = false;
    this.processing = true;

    if (this.file) {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("disk", "public");
      formData.append("folder", "uploaded");
      formData.append("mimes", 'mimes:png,jpg,jpeg,png,bmp,gif,webp,image,pdf');

      const response: any = await this.service.upload(formData).toPromise();

      this.form.patchValue({
        renamed: response?.renamed
      });

      const pdfResponse = await this.service.getPDFToText({
        renamed: response?.renamed
      }).toPromise();

      this.form.patchValue({
        description: JSON.stringify(pdfResponse)
      });
      const formDataToSave = { ...this.form.value, name: this.form.get('name')?.value || 'Letter of Authorization' };

      await this.service.saveFile(formDataToSave)
        .subscribe((response: any) => {
          this.toastr.success("Successfully uploaded the document");
          this.uploaded.emit(response);
          this.onClose();
          this.processing = false;
        }, (err) => {
          this.processing = false;
        });
    }
  }

  confirmUpload() {
    this.confirmationModal = true;
  }

  cancelUpload() {
    this.confirmationModal = false;
  }

  textInput: string = '';
  extractedData: any = null;
  showConfirmationModal: boolean = false;

  extractDetails() {
    if (!this.textInput.trim()) {
      console.log('No input text provided.');
      return;
    }

    // Clean and split input by tab
    const rawFields = this.textInput.split('\t');

    // Clean each field: trim, remove quotes, and newlines
    const fields = rawFields.map(field =>
      field
        .replace(/^"+|"+$/g, '') // remove surrounding quotes
        .replace(/\r?\n|\r/g, '') // remove \n and \r anywhere
        .trim() // trim spaces
    );


    // Normalize PH mobile number
    const normalizePHMobile = (number: string): string => {
      number = number.replace(/\D/g, ''); // Remove all non-digits

      if (number.startsWith('09') && number.length === 11) {
        return number; // Already in correct format
      } else if (number.startsWith('639') && number.length === 12) {
        return '0' + number.substring(2); // 63912... → 0912...
      } else if (number.startsWith('9') && number.length === 10) {
        return '0' + number; // 9123456789 → 09123456789
      }

      return number; // Fallback: return as-is
    };

    const mobile1 = normalizePHMobile(fields[11] || '');
    const mobile2 = normalizePHMobile(fields[12] || '');

    this.extractedData = {
      timestamp: fields[0] || '',
      approval_code: fields[1] || '',
      expiry_date: fields[2] || '',
      first_name: fields[3] || '',
      middle_name: fields[4] || '',
      last_name: fields[5] || '',
      gender: fields[6] || '',
      hmo_id: fields[7] || '',
      company: fields[8] || '',
      dob: fields[9] || '',
      chief_complaints: fields[10] || '',
      mobile1: mobile1,
      mobile2: mobile2,
      email: fields[13] || '',
      preferred_datetime: fields[14] || '',
      medical_certificate: fields[15] || '',
    };

    // Show confirmation modal
    this.showConfirmationModal = true;
    this.onClose();
  }





  async proceedWithData() {
    this.processing = true;
    this.confirmUpload();

    const missingFields = this.isDataValid();

    if (missingFields.length === 0) {
      const formData = new FormData();
      formData.append("disk", "public");
      formData.append("patient_id", "99999");
      formData.append("name", "Letter of Authorization");
      formData.append("description", JSON.stringify(this.extractedData)); // Convert to JSON string
      formData.append("source", "uploaded");
      formData.append("type", "application/pdf");
      formData.append("md_id", this.currentUser?.doctor?.md_id || '');

      await this.service.saveFile(formData)
        .subscribe((response: any) => {
          this.toastr.success("Successfully uploaded the document");
          this.uploaded.emit(response);
          this.onClose();
          this.cancelConfirmation();
          this.processing = false;
        }, (err) => {
          this.processing = false;
        });

    } else {
      this.toastr.error(`Invalid data. Please fill the required fields: ${missingFields.join(', ')}`);
      this.processing = false;
    }
  }

  cancelConfirmation() {
    this.showConfirmationModal = false;
  }

  isDataValid(): string[] {
    if (!this.extractedData) return ['No data extracted'];

    const requiredFields = [
      'first_name',
      'last_name',
      'gender',
      'dob',
      'mobile1',
      'email',
      'approval_code'];

    // Collect missing or invalid fields
    const missingFields = requiredFields.filter(
      field => !this.extractedData[field] || this.extractedData[field].trim() === 'N/A'
    );

    return missingFields;
  }

}
